/**
 * @author LiuMing
 * 字典反显
 */
export const formatter = (value, array = [], labelKey = 'label', valueKey = 'value') => {
    let find
    if (typeof value === 'number') {
        find = array.find(item => {
            return Number.parseInt(item[valueKey]) === value
        })
    } else {
        find = array.find(item => {
            return item[valueKey] === value
        })
    }
    if (find) {
        return find[labelKey]
    }
    return ''
}

/**
 * @author LiuMing
 * 获取经办人信息
 * @returns
 */
export const getManagerInfo = () => {
    // const userInfo = JSON.parse(localStorage.getItem("userInfo"));
    return {
        /**填写人 */
        createUserName: '管理员',
        /**填写单位 */
        createUserDeptName: '产品研发部门',
        /**填写部门 */
        createUserCompanyName: '融通地产',
        /**经办时间 */
        createTime: parseTime(new Date()),
    }
}

/**
 * 返回当前时间
 * @param {(Object|string|number)} time
 * @param {string} cFormat
 * @returns {string | null}
 */
export function parseTime(time, cFormat) {
    if (arguments.length === 0 || !time) {
        return null
    }
    const format = cFormat || '{y}-{m}-{d} {h}:{i}:{s}'
    let date
    if (typeof time === 'object') {
        date = time
    } else {
        if ((typeof time === 'string')) {
            if ((/^[0-9]+$/.test(time))) {
                time = parseInt(time)
            } else {
                time = time.replace(new RegExp(/-/gm), '/')
            }
        }

        if ((typeof time === 'number') && (time.toString().length === 10)) {
            time = time * 1000
        }
        date = new Date(time)
    }
    const formatObj = {
        y: date.getFullYear(),
        m: date.getMonth() + 1,
        d: date.getDate(),
        h: date.getHours(),
        i: date.getMinutes(),
        s: date.getSeconds(),
        a: date.getDay()
    }
    const time_str = format.replace(/{([ymdhisa])+}/g, (result, key) => {
        const value = formatObj[key]
        // Note: getDay() returns 0 on Sunday
        if (key === 'a') {
            return ['日', '一', '二', '三', '四', '五', '六'][value]
        }
        return value.toString().padStart(2, '0')
    })
    return time_str
}

/**
 * 将时间转换为易读的文字
 * @param {number} time
 * @param {string} option
 * @returns {string}
 */
export function formatTime(time, option) {
    if (('' + time).length === 10) {
        time = parseInt(time) * 1000
    } else {
        time = +time
    }
    const d = new Date(time)
    const now = Date.now()

    const diff = (now - d) / 1000

    if (diff < 30) {
        return '刚刚'
    } else if (diff < 3600) {
        // less 1 hour
        return Math.ceil(diff / 60) + '分钟前'
    } else if (diff < 3600 * 24) {
        return Math.ceil(diff / 3600) + '小时前'
    } else if (diff < 3600 * 24 * 2) {
        return '1天前'
    }
    if (option) {
        return parseTime(time, option)
    } else {
        return (
            d.getMonth() +
            1 +
            '月' +
            d.getDate() +
            '日' +
            d.getHours() +
            '时' +
            d.getMinutes() +
            '分'
        )
    }
}

/**
 * @description 将组织架构List转换为Tree
 * @author LiuMing
 * @param {Array} list 将要处理的List
 * @param {String | Number} id 子级关联父级顶级标识的值
 * @param {String} key 唯一标识的key
 * @param {String} parentId 子级关联父级唯一标识的key
 * @returns
 */

export function ListToTree(list, topParentId = null, key = "id", parentId = "smartParentId") {
    /**对源数据深度克隆 */
        // const cloneData = JSON.parse(JSON.stringify(list));
    const cloneData = list
    // const cloneData = cloneDeep(list)
    /**将返回的Tree */
    const tree = []
    /**遍历 */
    cloneData.forEach((father) => {
        /**拿到每一项的子级数组 */
        const branchArr = cloneData.filter(
            (child) => father[key] === child[parentId]
        );
        if (branchArr.length) {
            //存在子集，父级children属性赋值为子集
            father.children = branchArr

            // father.hasChildren = true
        } else {
            //不存在子集, 父级children赋值为null
            // father.children = null
        }
        /**返回 */
        if (father[parentId] === topParentId) {
            tree.push(father)
        }
    });
    return tree
}

/**
 * @description 将menuList转换为Tree
 * @author LiuMing
 * @param {Array} list 将要处理的List
 * @param {String | Number} id 子级关联父级顶级标识的值
 * @param {String} key 唯一标识的key
 * @param {String} parentId 子级关联父级唯一标识的key
 * @returns
 */

export function menuListToTree(list, topParentId = null, key = "id", parentId = "pid") {
    /**对源数据深度克隆 */
        // const cloneData = JSON.parse(JSON.stringify(list));
    const cloneData = list.sort((a, b) => {
            return a.smartOrder - b.smartOrder
        })
    // const cloneData = cloneDeep(list)
    /**将返回的Tree */
    const tree = []
    /**遍历 */
    cloneData.forEach((father) => {
        /**拿到每一项的子级数组 */
        const branchArr = cloneData.filter(
            (child) => father[key] === child[parentId]
        );
        if (branchArr.length) {
            //存在子集，父级children属性赋值为子集
            father.children = branchArr

            // father.hasChildren = true
        } else {
            //不存在子集, 父级children赋值为null
            // father.children = null
        }
        /**返回 */
        if (father[parentId] === topParentId) {
            tree.push(father)
        }
    });
    return tree
}

function cloneDeep(data, hash = new WeakMap()) {
    if (typeof data !== 'object' || data === null) {
        throw new TypeError('传入参数不是对象')
    }
    // 判断传入的待拷贝对象的引用是否存在于hash中
    if (hash.has(data)) {
        return hash.get(data)
    }
    let newData = {};
    const dataKeys = Object.keys(data);
    dataKeys.forEach(value => {
        const currentDataValue = data[value];
        // 基本数据类型的值和函数直接赋值拷贝
        if (typeof currentDataValue !== "object" || currentDataValue === null) {
            newData[value] = currentDataValue;
        } else if (Array.isArray(currentDataValue)) {
            // 实现数组的深拷贝
            newData[value] = [...currentDataValue];
        } else if (currentDataValue instanceof Set) {
            // 实现set数据的深拷贝
            newData[value] = new Set([...currentDataValue]);
        } else if (currentDataValue instanceof Map) {
            // 实现map数据的深拷贝
            newData[value] = new Map([...currentDataValue]);
        } else {
            // 将这个待拷贝对象的引用存于hash中
            hash.set(data, data)
            // 普通对象则递归赋值
            newData[value] = cloneDeep(currentDataValue, hash);
        }
    });
    return newData;
}
